import { AddBusinessDetailsPrompt } from "@/components/AddBusinessDetailsPrompt";
import { Button } from "@/components/ui/button/button";
import { businessDetailsCreateRoute, newAccountRoute } from "@/router";
import { useLoaderData, useNavigate } from "@tanstack/react-router";
import SoftpointIframeDataFetcher from "./SoftpointIframe/SoftpointIframe";

const NewAccountPage = () => {
	const navigate = useNavigate();
	const {
		user: { guest_business_details },
	} = useLoaderData({
		from: "/main",
	});

	const primaryBusiness = guest_business_details[0];
	const companyNameFromGuestBusiness =
		primaryBusiness?.business_name?.trim() ?? "";

	if (guest_business_details.length === 0 || !companyNameFromGuestBusiness) {
		return (
			<AddBusinessDetailsPrompt>
				<Button
					type="button"
					className="w-full"
					onClick={() =>
						navigate({
							to: businessDetailsCreateRoute.to,
							search: {
								callback: newAccountRoute.to,
							},
						})
					}
				>
					Add business details
				</Button>
			</AddBusinessDetailsPrompt>
		);
	}

	return (
		<div className="max-w-container mx-auto px-6">
			<SoftpointIframeDataFetcher companyName={companyNameFromGuestBusiness} />
		</div>
	);
};

export default NewAccountPage;
